import { Component, OnInit } from '@angular/core';
import { DynamicFormComponent } from '@components/dynamic-form/dynamic-form.component';
import { Router } from '@angular/router';
import { UserService } from '@services/admin/user.service';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { LoggerService } from '@services/logger.service';
import { ActionPracticesService } from '@services/data-source-tables/action-practices.service';
import { ActionPracticeFormSetting } from '@/form-settings/action-practice-form-setting';
import { ActionPracticesModel } from '@/models/tables/action-practices.model';
import { OptionSelect } from '@/models/option-select.model';

@Component({
  selector: 'app-action-practice-form',
  templateUrl: '../../../../../components/dynamic-form/dynamic-form.component.html',
})
export class ActionPracticeFormComponent extends DynamicFormComponent implements OnInit {
  private brands: OptionSelect[] = [];

  constructor(
    protected router: Router,
    protected userService: UserService,
    protected actionPracticesService: ActionPracticesService,
    protected toastr: ToastrService,
  ) {
    super(toastr, userService);

    this.setupMeta();
    this.submitButtonVisible = true;
    this.primaryButton = 'Salva';
    this.secondaryBottomButton = 'Chiudi';

    Registry.getInstance().set('ActionPracticeFormComponent', this);

    this.actionPracticesService.getAllBrands().subscribe({
      next: (brands) => {
        for (let brand of brands) {
          this.brands.push({
            key: brand,
            value: brand,
          });
        }

        this.setupMeta();
      },
      error: (error) => {
        LoggerService.error('getAllBrands failed!');
        LoggerService.error(error);
      },
      complete: () => {
        LoggerService.log('Request done');
      },
    });
  }

  ngOnInit(): void {
    this.form.controls['creator'].setValue(this.userService.getUserName());
  }

  onSubmit() {
    let actionPractices = <ActionPracticesModel>this.form.getRawValue();

    this.actionPracticesService.saveActionPractice(actionPractices).subscribe({
      next: () => {
        this.toastr.success('Azione pratica salvata correttamente!');

        this.closeModalAndRefresh();
      },
      error: (error) => {
        LoggerService.error('saveActionPractice failed!');
        LoggerService.error(error);

        this.toastr.error(`Errore durante il salvataggio dell'Azione pratica.`);

        setTimeout(() => {
          Registry.getInstance().set('saveInProgress', false);
        }, 1000);
      },
      complete: () => {
        LoggerService.log('Request done');
        setTimeout(() => {
          Registry.getInstance().set('saveInProgress', false);
        }, 1000);
      },
    });
  }

  setupMeta(): void {
    this.meta = ActionPracticeFormSetting.set('brands', this.brands)
      .getMeta()
      .sort((a: any, b: any) => a.order - b.order);
  }

  bottomButtonAction() {
    if (this.data.id) {
      Registry.getInstance().get('DialogActionPracticeComponentModify').close();
    } else {
      Registry.getInstance().get('DialogActionPracticeComponentNew').close();
    }
  }

  protected closeModalAndRefresh() {
    if (this.data.id) {
      Registry.getInstance().get('DialogActionPracticeComponentModify').close();
    } else {
      Registry.getInstance().get('DialogActionPracticeComponentNew').close();
    }

    Registry.getInstance().get('ActionPracticesComponent').loadActionPractices();
  }
}
